import _extends from "@babel/runtime/helpers/esm/extends";
import ensureIdentity from './entity-helpers/ensureIdentity';
import createSubjectId from './createSubjectId';
export default function ensureIndirectSubjectId(rule, subject) {
  return _extends({}, subject, {
    id: createSubjectId(ensureIdentity('entity', subject.product), rule.ruleCode)
  });
}